var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSendIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 8.664,
    height: 12.387,
    viewBox: "0 0 8.664 12.387",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "down-filled-triangular-arrow",
    transform: "translate(8.664) rotate(90)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1081",
    "data-name": "Path 1081",
    d: "M11.79,8.664H.6c-.53,0-.8-.816-.42-1.3L5.774.22a.51.51,0,0,1,.84,0l5.6,7.143C12.589,7.848,12.32,8.664,11.79,8.664Z",
    transform: "translate(0 0)",
    fill: "#5cc13e"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSendIcon);
export default __webpack_public_path__ + "static/media/sendIcon_.18346cf6deade6672e7c4f405692abf9.svg";
export { ForwardRef as ReactComponent };